import { DefaultButton } from "../../common/components/button/defaultButton/DefaultButton";
import { MetricCard } from "./MetricCard/MetricCard";
import { DetailModal } from "./DetailModal/DetailModal";
import { CalendarModal } from "./CalendarModal/CalendarModal";
import { CustomizationDropdown } from "./CustomizationDropdown/CustomizationDropdown";
import { getMetricPropertyName } from "../../common/infrastructure/config/metricPropertyMapping";
import { useDashboard } from "./hooks/useDashboard";
import styles from "./Dashboard.module.scss";

export const Dashboard = () => {
  const {
    selectedStartDate,
    selectedEndDate,
    isCalendarOpen,
    isCustomizationOpen,
    isDetailModalOpen,
    togglingMetricKey,
    selectedMetricKey,
    metricsData,
    isMetricsLoading,
    metricsError,
    detailData,
    isDetailLoading,
    currentDisabledMetrics,
    visibleMetrics,
    customizationMetrics,
    selectedMetricConfig,
    handleDateRangeChange,
    handleMetricCardClick,
    handleCustomizationToggle,
    handleDetailModalClose,
    formatDateRange,
    setIsCalendarOpen,
    setIsCustomizationOpen,
  } = useDashboard();

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardContent}>
        <div className={styles.controls}>
          <div className={styles.dateControl}>
            <button
              type="button"
              className={styles.dateInput}
              onClick={() => setIsCalendarOpen(true)}
            >
              <span className={styles.dateIcon}>📅</span>
              <span className={styles.dateText}>{formatDateRange()}</span>
            </button>
          </div>

          <div className={styles.customizationControl}>
            <DefaultButton
              design="outline"
              label="Персонализиране"
              onClick={() => setIsCustomizationOpen(!isCustomizationOpen)}
              className={styles.customizationButton}
            />

            <CustomizationDropdown
              isOpen={isCustomizationOpen}
              onClose={() => setIsCustomizationOpen(false)}
              metrics={customizationMetrics}
              disabledMetrics={currentDisabledMetrics}
              onToggle={handleCustomizationToggle}
              togglingMetricKey={togglingMetricKey}
            />
          </div>
        </div>

        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Метрики за периода</h2>
          <p className={styles.sectionSubtitle}>
            Общо {visibleMetrics.length} активни
          </p>
        </div>
        {metricsError ? (
          <div className={styles.errorState}>
            <span className={styles.errorIcon}>⚠️</span>
            <h3 className={styles.errorTitle}>
              Грешка при зареждане на данните
            </h3>
            <p className={styles.errorMessage}>
              Моля, опитайте отново или се свържете с поддръжката.
            </p>
          </div>
        ) : (
          <div className={styles.metricsGrid}>
            {visibleMetrics.map((metric) => {
              const propertyName = getMetricPropertyName(metric.key);
              const metricData = metricsData?.metrics?.[propertyName];
              const isToggling = togglingMetricKey === metric.key;

              return (
                <MetricCard
                  key={metric.key}
                  config={metric}
                  data={metricData}
                  isLoading={isMetricsLoading || isToggling}
                  onClick={() => handleMetricCardClick(metric.key)}
                />
              );
            })}
          </div>
        )}
      </div>
      <CalendarModal
        isOpen={isCalendarOpen}
        onClose={() => setIsCalendarOpen(false)}
        onApply={handleDateRangeChange}
        initialStartDate={selectedStartDate}
        initialEndDate={selectedEndDate}
      />

      <DetailModal
        isOpen={isDetailModalOpen}
        onClose={handleDetailModalClose}
        title={selectedMetricConfig?.title || ""}
        items={detailData?.items}
        isLoading={isDetailLoading}
        metricKey={selectedMetricKey}
      />
    </div>
  );
};
